export interface ArrowIconProps {
  direction?: "left" | "right";
  /** The designer draws 24px on the next button and 20px on the back button. */
  size?: number;
}

// Both vectors span 25%–75%: the shaft along the mid-line, the head a quarter wide and half tall.
export default function ArrowIcon({ direction = "right", size = 24 }: ArrowIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
      style={direction === "left" ? { transform: "rotate(180deg)" } : undefined}
    >
      <path d="M6 12h12" />
      <path d="M12 6l6 6-6 6" />
    </svg>
  );
}
